import { Component, OnInit, AfterViewInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { UiHelper } from '@helpers/ui.helper';
import { ApiService } from '@services/api.service';
import { LocalizationService } from '@services/localization.service';
import { TranslatePipe } from '@pipes/translate.pipe';
import { EasyPasswordEnabled, passwordRegex } from '@environments/environment';
import { UserHelper } from '@app/helpers/user.helper';
@Component({
  selector: 'change-password',
  templateUrl: '../sharedTemplates/change-password.component.html',
})
export class ChangePasswordComponent implements OnInit, AfterViewInit {
  changePasswordDatas: UntypedFormGroup;
  changePasswordDataRaw: any;
  private passwordRegex = passwordRegex;
  constructor(
    public _UserHelper: UserHelper,
    private _UiHelper: UiHelper,
    private _FormBuilder: UntypedFormBuilder,
    private _ApiService: ApiService,
    private _LocalizationService: LocalizationService
  ) {
    if (EasyPasswordEnabled) {
      this.changePasswordDatas = _FormBuilder.group({
        oldPassword: new UntypedFormControl({ value: '', disabled: false }, [Validators.required, Validators.minLength(3)]),
        newPassword: new UntypedFormControl({ value: '', disabled: false }, [Validators.required, Validators.pattern('^.{6,35}$')]),
        reNewPassword: new UntypedFormControl({ value: '', disabled: false }, [Validators.required, Validators.pattern('^.{6,35}$')]),
      });
    } else {
      this.changePasswordDatas = _FormBuilder.group({
        oldPassword: new UntypedFormControl({ value: '', disabled: false }, [Validators.required, Validators.minLength(3)]),
        newPassword: new UntypedFormControl({ value: '', disabled: false }, [Validators.required, Validators.pattern(this.passwordRegex)]),
        reNewPassword: new UntypedFormControl({ value: '', disabled: false }, [Validators.required, Validators.pattern(this.passwordRegex)]),
      });
    }
  }

  ngOnInit() {
    this.changePasswordDatas.valueChanges.subscribe(x => {
      this.changePasswordDataRaw = x;
    });
  }

  ngAfterViewInit() {
    if (this._UiHelper.rightMenu) this._UiHelper.setRightMenu();
    this._UiHelper.setNavbarTitle('ChangePassword');
  }

  submitChangePasswordData() {
    const translator = new TranslatePipe(this._LocalizationService);
    this._ApiService.changePassword(this.changePasswordDataRaw).then(result => {
      if (result.code == '') {
        return 'error|System Error';
      } else {
        if (result.code == 'error') {
          this._UiHelper.errorSnackBar(result.message, '');
        } else if (result.code == 'errorcode') {
          const t_message = translator.transform(result.message, null);
          this._UiHelper.errorSnackBar(t_message, '');
        } else if (result.code == 'success') {
          const t_message = translator.transform(result.message, null);
          this._UiHelper.successSnackBar(t_message, '');
          this.changePasswordDatas.controls.oldPassword.disable();
          this.changePasswordDatas.controls.newPassword.disable();
          this.changePasswordDatas.controls.reNewPassword.disable();
          this.signOut();
        }
      }
    });
  }

  signOut() {
    this._ApiService
      .signOut()
      .then(result => {
        this._UserHelper.userLogOut();

        this.refreshAPP();
      })
      .catch(err => console.log('idle.dialog', err));
  }
  refreshAPP() {
    window.location.href = '/home';
  }
}
